import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { AutoSizer } from "react-virtualized";
import clsx from "clsx";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import Loader from "components/Loader";
import { useRacehorse360Api } from "hooks/api";
import useStyles from "./styles";

interface IProps {
  stallApplicationFormId: string;
  onClose: () => void;
}

const TermsAndConditionsPopup = (props: IProps) => {
  const { stallApplicationFormId, onClose } = props;

  const classes = useStyles();
  const [isPdfDocLoading, setIsPdfDocLoading] = useState<boolean>(true);
  const [arePdfPagesLoading, setArePdfPagesLoading] = useState<boolean[]>([]);
  const [pagesNumber, setPagesNumber] = useState<number>(0);

  const { usePullStallApplicationFormTermsFileSignedUrl } =
    useRacehorse360Api();

  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

  const { data, isLoading: isStallApplicationFormLoading } =
    usePullStallApplicationFormTermsFileSignedUrl({
      stallApplicationFormId
    });
  const termsFileUrl = data?.signedUrl;

  const isLoading = [
    isStallApplicationFormLoading,
    isPdfDocLoading,
    ...arePdfPagesLoading
  ].some(Boolean);

  const handleDocLoadSuccess = ({ numPages }: { numPages: number }) => {
    setIsPdfDocLoading(false);
    setPagesNumber(numPages);
    setArePdfPagesLoading(new Array<boolean>(numPages));
  };

  const handleDocLoadError = () => {
    setIsPdfDocLoading(false);
    setArePdfPagesLoading(new Array<boolean>(0));
  };

  const handlePageRenderSuccess = (index: number) => () => {
    setArePdfPagesLoading(
      arePdfPagesLoading.map((val, i) => i === index || val)
    );
  };

  return (
    <Dialog open className={classes.root} onClose={onClose}>
      <DialogTitle>
        <span>Terms & Conditions</span>
        <IconButton
          color="primary"
          size={"small"}
          classes={{ root: classes.dialogCloseButton }}
          onClick={onClose}
        >
          <CloseIcon className={classes.dialogCloseButtonIcon} />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className={clsx(classes.dialogContent, {
          [classes.isLoadingErrorShown]: !arePdfPagesLoading.length
        })}
      >
        {isLoading && <Loader overlay />}
        <AutoSizer disableHeight>
          {({ width }) => (
            <Document
              className={clsx(classes.pdfDocument, {
                [classes.hidden]: isLoading
              })}
              file={termsFileUrl}
              onLoadSuccess={handleDocLoadSuccess}
              onLoadError={handleDocLoadError}
            >
              {Array.from(new Array(pagesNumber), (el, index) => (
                <Page
                  key={`page_${index + 1}`}
                  pageNumber={index + 1}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  width={width}
                  onRenderSuccess={handlePageRenderSuccess(index)}
                />
              ))}
            </Document>
          )}
        </AutoSizer>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(TermsAndConditionsPopup);
